export let RuleValidationStatus = /*#__PURE__*/function (RuleValidationStatus) {
  RuleValidationStatus["BothGreaterThanNumOfModifiers"] = "BothGreaterThanNumOfModifiers";
  RuleValidationStatus["MinGreaterThanNumOfModifiers"] = "MinGreaterThanNumOfModifiers";
  RuleValidationStatus["MinGreaterThanMax"] = "MinGreaterThanMax";
  RuleValidationStatus["MaxGreaterThanNumOfModifiers"] = "MaxGreaterThanNumOfModifiers";
  RuleValidationStatus["MaxUnlimitedAndNumOfModifiersLargerThanPossibleToSelect"] = "MaxUnlimitedAndNumOfModifiersLargerThanPossibleToSelect";
  RuleValidationStatus["OK"] = "OK";
  return RuleValidationStatus;
}({});
export let PreSelectionValidationStatus = /*#__PURE__*/function (PreSelectionValidationStatus) {
  PreSelectionValidationStatus["NumOfPreSelectedModifiersGreaterThanMax"] = "NumOfPreSelectedModifiersGreaterThanMax";
  PreSelectionValidationStatus["NumOfPreSelectedModifiersCannotExceedMaxAllowed"] = "NumOfPreSelectedModifiersCannotExceedMaxAllowed";
  PreSelectionValidationStatus["OK"] = "OK";
  return PreSelectionValidationStatus;
}({});
//# sourceMappingURL=modifiers.js.map